module.exports = __webpack_public_path__ + "img/26.edc0b746.jpg";